import * as swcHelpers from '@swc/helpers';
import { useLink } from '@grandvisionhq/frk-routing';
import { appendQueryParamToUrl } from '@grandvisionhq/utils';

const useGoToCheckoutLink = (cartId)=>{
    const { onClick: navigateLogin , href: hrefLogin  } = useLink({
        route: 'checkout.login'
    }) || {};
    const { onClick: navigateShipping , href: hrefShipping  } = useLink({
        route: 'checkout.shipping'
    }) || {};
    const hrefWithCartId = appendQueryParamToUrl(hrefLogin || hrefShipping || '/checkout/shipping', swcHelpers.objectSpread({}, cartId ? {
        cartId
    } : null));
    if (!hrefLogin && !hrefShipping) {
        console.error('This opco is not setup properly. You need to have at least the shipping page configured.');
    }
    return {
        onClick: navigateLogin || navigateShipping,
        href: hrefWithCartId
    };
};

export { useGoToCheckoutLink };
//# sourceMappingURL=use-go-to-checkout-link.js.map
